<template>
    <div class="tree">
          <div class="tree-item" v-for="item in dataSet1">

            <div class="tree-item-content" v-if="!item.isDelete" :class="{highlight:!!item.highlight}" :style="{paddingLeft:(level2*18) + 'px'}">
                    <template v-if="item.hasChild">
                        <span v-if="item.hasOwnProperty('isExpand')? !item.isExpand : !edit.isExpand" @click="expand(item,!!edit.isExpand)" class="tree-item-expand el-icon-caret-right" ></span>
                        <span v-if="item.hasOwnProperty('isExpand')? !!item.isExpand : !!edit.isExpand" @click="expand(item,!!edit.isExpand)" class="tree-item-expand el-icon-caret-bottom" ></span>
                    </template>
                    <template v-else>
                        <span class="tree-item-expand el-icon-caret-right is-leaf"></span>
                    </template>

                    <template v-if="item.hasOwnProperty('showCheckBox') ? !!item.showCheckBox : !!edit.showCheckBox">
                        <span class="tree-item-text" :style="{paddingRight: editTimes*20 + 5 + 'px'}" @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)">
                            <template v-if="!!edit.textBindEvent">
                                <el-checkbox v-model="item.isChecked" :checked="item.isChecked" :indeterminate="!!item.isIndeterminate"  @change="checkboxChange(item)" :disabled="!!item.disabled" :title="item.text">
                                </el-checkbox>
                                <span v-html="item.text" style="margin-left:10px" @click="nodeTextClick(item)">{{item.text}}</span>                                
                            </template> 
                            <template v-else>
                                <el-checkbox v-model="item.isChecked" :checked="item.isChecked" :indeterminate="!!item.isIndeterminate"  @change="checkboxChange(item)" :disabled="!!item.disabled"  :title="item.text">
                                    <span v-html="item.text">{{item.text}}</span>                                
                                </el-checkbox>
                            </template> 
                            <span v-if="item.hoverShow || item.highlight" class="operate">
                                <i v-if="!!edit.showRemoveBtn" class="el-icon-delete" @click="removeNode(item)"></i>
                                <i v-if="!!edit.showRenameBtn" class="el-icon-edit" @click="renameNode(item)"></i>
                                <i v-if="!!edit.showAddBtn" class="el-icon-plus" @click="addNode(item)"></i>
                                <slot name="extend"></slot>
                            </span>
                        </span>
                    </template>
                    <template v-else>
                        <span class="tree-item-text" :style="{paddingRight: editTimes*20 + 5 + 'px'}" @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)">
                            <span :title="item.text" @click="checkNode(item)" v-html="item.text">{{item.text}}</span>
                            <span v-if="item.hoverShow || item.highlight" class="operate">
                                <i v-if="!!edit.showRemoveBtn" class="el-icon-delete" @click="removeNode(item)"></i>
                                <i v-if="!!edit.showRenameBtn" class="el-icon-edit" @click="renameNode(item)"></i>
                                <i v-if="!!edit.showAddBtn" class="el-icon-plus" @click="addNode(item)"></i>
                                <slot name="extend"></slot>
                            </span>
                        </span>
                    </template>
                </div>

                <div class="tree-item-children">
                    <ip-tree v-if="item.hasOwnProperty('isExpand')? !!item.isExpand : !!edit.isExpand"
                        :data-set="item.children"
                        :edit="edit"
                        :parent="item"
                        :level="+level2"
                        :checked-parent-node="checkedParentNode"
                        @nodeClick="handleNodeClick"
                        @removeNode="handleRemoveNode"
                        @renameNode="handleRenameNode"
                        @addNode="handleAddNode"
                        @expandEvent="handleExpandEvent"
                        @checkboxChangeEvent="handleCheckboxChangeEvent"
                        @nodeTextClick="handleNodeTextClick">
                        <template slot="extend">
                            <slot name="extend"></slot>    
                        </template>
                    </ip-tree>
                </div>
            </div>
    </div>

</template>

<script>
    export default {
        name: "ipTree",
        props: {
            dataSet: {
                type:Array,
                default(){
                    return []
                },
                required:true
            },
            edit:{
                type:Object,
                default(){
                    return {}
                }
            },
            parent:{
                type:Object,
                default(){
                    return {}
                }
            },
            level:{
                type:Number,
                default:0
            },
            checkedParentNode:{
                type:Boolean,
                default:false
            },
            filterNodeMethod:{
                type:Function,
                default(){
                //   console.log('aaaa'); 
                }
            }
        },
        data(){
            return{
                hoverShow:false,
                editTimes:0,
                dataSetCopy:[],
                dataSet1:[],
            }
        },
        computed:{
            level2:{
                get(){
                    return this.level + 1
                },
                set(){}
            }
        },
        watch:{
            dataSet(nv,ov){
                this.dataSet1 = nv;
            }
        },
        mounted () {
            if(!!this.edit.showRemoveBtn){
                this.editTimes++;
            }
            if(!!this.edit.showRenameBtn){
                this.editTimes++;
            }
            if(!!this.edit.showAddBtn){
                this.editTimes++;
            }
            this.dataSetCopy = JSON.parse(JSON.stringify(this.dataSet));
            this.dataSet1 = this.dataSet;
        },
        methods: {
            nodeTextClick(item){
                this.$emit('nodeTextClick',item);
            },
            handleNodeTextClick(item){
                this.$emit('nodeTextClick',item);
            },
            filter(value){
                var self = this;
                var tempDataSet = JSON.parse(JSON.stringify(this.dataSetCopy));
                if(value){
                    tempDataSet.forEach(element => {
                        var regStr = "(" + value + ")";
                        var reg = new RegExp(regStr,"g");
                        var newStr = element.text.replace(reg, "<span style=\"color: red\">$1</span>");
                        element.text = newStr;
                        self.filterChildren(element,value);
                    });
                }
                this.dataSet1 = tempDataSet;
            },
            filterChildren(element,value){
                var self = this;
                var regStr = "(" + value + ")";
                var reg = new RegExp(regStr,"g");
                if(element.children){
                    element.children.forEach(item =>{
                        if(item.text.indexOf(value) > -1){
                            element.isExpand = true;
                        }
                        var newStr = item.text.replace(reg, "<span style=\"color: red\">$1</span>");
                        item.text = newStr;
                        self.filterChildren(item,value);
                    })
                }
            },
            expand (item,tag) {
                if (!!item.children) {
                    if (item.hasOwnProperty('isExpand')) {
                            item.isExpand = !item.isExpand;
                    }else{
                        this.$set(item,'isExpand',!tag);
                    }
                    this.$emit('expandEvent', item);                    
                }
            },
            checkNode(item){
                this.$emit('nodeClick',item,this.parent);
            },
            checkboxChange (item) {
                var changeList = [];
                this.$set(item,'isIndeterminate',false);
                this.$emit('checkboxChangeEvent', item,this.parent,changeList,this.parent);
            },
            handleExpandEvent(data) {
                this.$emit('expandEvent', data);
            },
            handleCheckboxChangeEvent(data,father,changeList,parent) {
                if(!!this.checkedParentNode){
                    if(!!parent){
                        if(!!data.isChecked){
                            var _temp = true;
                            if(parent.children){
                                parent.children.forEach(item=>{
                                if(!item.isChecked){
                                    _temp = false;
                                }
                                })
                            }
                            if(!_temp){
                                 if(!parent.isIndeterminate && !parent.isChecked){
                                    changeList.push(parent);
                                }
                                this.$set(parent,'isIndeterminate',true)
                            }else{
                                if(!parent.isChecked && !parent.isIndeterminate){
                                    changeList.push(parent);    
                                }
                                this.$set(parent,'isChecked',true)
                                this.$set(parent,'isIndeterminate',false)
                            }
                        }else{
                            var _temp = false;
                            if(parent.children){
                                parent.children.forEach(item=>{
                                if(!!item.isChecked || !!item.isIndeterminate){
                                    _temp = true;
                                }
                                })
                            }
                            if(_temp){
                                if(!!parent.isChecked && !!parent.isIndeterminate){
                                    changeList.push(parent);
                                }
                                this.$set(parent,'isChecked',false)
                                this.$set(parent,'isIndeterminate',true)
                            }else{
                                if(!!parent.isChecked || !!parent.isIndeterminate){
                                    changeList.push(parent);
                                    this.$set(parent,'isChecked',false)
                                    this.$set(parent,'isIndeterminate',false) 
                                }
                            }
                        }
                    }
                }                
                this.$emit('checkboxChangeEvent',data,father,changeList,this.parent);
            },
            handleNodeClick(data,parent){
                this.$emit('nodeClick',data,parent);
            },
            removeNode(item){
                this.$emit('removeNode',item,this.parent);
            },
            renameNode(item){
                this.$emit('renameNode',item);
            },
            addNode(item){
                this.$emit('addNode',item);
            },
            handleRemoveNode(item,parent){
                this.$emit('removeNode',item,parent);
            },
            handleRenameNode(item){
                this.$emit('renameNode',item);
            },
            handleAddNode(item){
                 this.$emit('addNode',item);
            },
            mouseenter(item){
                this.$set(item,'hoverShow',true);
            },
            mouseleave(item){
                item.hoverShow = false;
            }
        }// end of methods
    }
</script>

<style lang="scss">
.tree{
    .tree-item-content{
        .el-checkbox__input.is-disabled+span.el-checkbox__label{
            color: #606266;
            cursor: default;
        }
    }
}
</style>

<style lang="scss" scoped>
    .tree {
        position: relative;
        cursor: default;
        background: #fff;
        color: #606266;
        .tree-item {
            white-space: nowrap;
            outline: 0;
            padding-left: 0px;
            .highlight{
                background: #d4efff;
            }
            .tree-item-content {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                align-items: center;
                height: 26px;
                cursor: pointer;
                padding-left: 10px;
                line-height: 19px;
                font-size: 14px;   
                .tree-item-text{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    position: relative;
                }
                .tree-item-expand {
                    padding: 6px;
                    cursor: pointer;
                    color: #c0c4cc;
                    font-size: 12px;
                    -webkit-transform: rotate(0);
                    transform: rotate(0);
                    -webkit-transition: -webkit-transform .3s ease-in-out;
                    transition: -webkit-transform .3s ease-in-out;
                    transition: transform .3s ease-in-out;
                    transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;
                    transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out
                }
                .is-leaf {
                    color: transparent;
                    cursor: default;
                }
                .operate{
                    position: absolute;
                    right: 0;
                    i{
                        font-size: 15px;
                        margin: 0 3px;
                    }
                    i:hover{
                        color: #2F7ECE;
                    }
                }  
            }
            .tree-item-children {
                display: block;
                overflow: hidden;
                background-color: transparent;
            }
        }
    }
</style>